
<div *ngIf="exportService && config && model">
    <mat-card appearance="outlined" class="cl-export-container">
        <mat-card-content>

            <div class="cl-export-header">
                <mat-card-title>
                    <mat-icon>{{ config.icon | translate }} </mat-icon>
                    <span>{{ config.title | translate }}</span>
                </mat-card-title>
                <ng-container *ngIf="viewActions">
                    <ant-view-action
                            *ngFor="let viewAction of viewActions"
                            [viewAction]="viewAction"
                            [context]="model">
                    </ant-view-action>
                </ng-container>
            </div>

            <p class="cl-description">{{ config.description | translate }}</p>

            <ng-container *ngIf="model.files">
                <div class="cl-included-files" *ngFor="let file of model.files">
                    <mat-checkbox color="primary"
                                  [disabled]="true"
                                  [checked]="file.isSelected">
                    </mat-checkbox>
                    <p>{{ file.filename | translate }}</p>
                </div>
            </ng-container>

        </mat-card-content>
    </mat-card>
</div>
